//@flow
import React from 'react';
import Input from './Input.react';

/**
This is a wrapper for the formsy Input component. It shows a placeholder
when the input doesn't have text, and shows a floating label otherwise.
The css class is defined as float-wrapper in partials/_global.scss. The component
needs a title prop and a showFloat={true} prop in order to display properly,
as well as the props that you would normally pass to the Input component.
*/
type Props = {
  className?:string,
  labelClassName?:string,
  inputLabelClassName?:string,
  showFloat?:boolean,
  value?:string,
  type:'password'|'text'|'tel'|'email'|'date',
  onChange?:(e:SyntheticInputEvent<HTMLInputElement>)=>void,
  setValue?:?string,
};

type State = {
  className:string,
};

export default class FloatLabelInput extends React.Component<Props, State> {
  state = { className: '' };

  handleChange = (event:SyntheticInputEvent<HTMLInputElement>) => {
    if (event.target.value !== '') {
      this.setState({className: 'on'});
    } else {
      this.setState({className: ''});
    }

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  componentDidMount() {
    if (this.props.setValue) {
      this.setState({className: 'on'}); // eslint-disable-line react/no-did-mount-set-state
    }
  }

  _getInputProps() {
    const inputProps = Object.assign({}, this.props);
    if (this.props.showFloat) {
      delete inputProps.className;
    }
    delete inputProps.onChange;
    delete inputProps.showFloat;

    return inputProps;
  }

  _getClassName() {
    const className = this.props.className || '';
    return `${className} float-wrapper`;
  }

  _getProps() {
    const props = this._getInputProps();
    if (!this.props.showFloat) {
      return props;
    }
    props.className = this._getClassName();
    props.onChange = this.handleChange;
    if (this.props.inputLabelClassName) {
      props.inputLabelClassName = `${this.props.inputLabelClassName} ${this.state.className}`;
    } else {
      props.inputLabelClassName = this.state.className;
    }

    return props;
  }

  render() {
    return (
      <Input
        {...this._getProps()}
      />
    );
  }
}
